import axiosService from "common/axiosService";
import { API_URL } from "common/defines";

export const analytics = async () => {
    return await axiosService.get(API_URL + "/dashboard");
};
